import { NgModule } from '@angular/core';
import { I18nTranslateLoader } from '@app-i18n/i18n.loader';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService
} from '@ngx-translate/core';

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: I18nTranslateLoader
      }
    })
  ],
  exports: [TranslateModule]
})
export class I18nModule {
  constructor(private _translate: TranslateService) {
    this._translate.setDefaultLang('nl');
    this._translate.use('nl');
  }
}
